export const STATUS_UPLOAD = {
    uploading: 0,
    success: 1,
    failed: 2
}